<template>
<svg xmlns="http://www.w3.org/2000/svg" width="19.505" height="33.01" viewBox="0 0 19.505 33.01">
<path id="Path_111" data-name="Path 111" d="M498.842,3107.294l12.262,12.262,12.262-12.262" transform="translate(3122.557 -494.599) rotate(90)" fill="none" stroke="#e6041e" stroke-linecap="round" stroke-linejoin="round" stroke-width="6"/>
</svg>
</template>